// src/pages/MyCloudPage.jsx
import React from 'react';
import CloudExplorer from '../components/cloud/CloudExplorer';

const MyCloudPage = () => {
    // L'endpoint per i file dell'utente loggato
    const endpoint = '/cloud/files';
    
    return <CloudExplorer listFilesEndpoint={endpoint} />;
};

export default MyCloudPage;